import { Div, RefString, TextInput } from "@tblabs/truffle";



export class SvgEditor extends Div
{
    constructor(icon: RefString)
    {
        super();
        this.Style(`display: inline-block; text-align: justify`);

        const svg = new Div().Html(icon.value).Width(32).DisplayInlineBlock().MarginLeft(12);

        icon.OnChange(v => svg.Html(v));

        this.Append(
            new TextInput(icon).Placeholder("SVG").Width(100).DisplayInlineBlock(),
            svg
        );
    }
}
